











































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Board } from '../../../common/board';
import { Box } from '../../../common/box';
import wamp, { submitSimulation } from '../wamp';
import { boardSubmitSimulation } from '../simulation';
import BoardInspector from '@/BoardInspector.vue';
import gql from 'graphql-tag';
import _ from 'lodash';

import * as BOARD_DESCRIPTION_FRAGMENT_QUERY from 'src/graphql/BoardDescriptionFragment.graphql';
import * as BOARD_USE_CUSTOM_BPI_FRAGMENT_QUERY from 'src/graphql/BoardUseCustomBPIFragment.graphql';
import * as BOARD_CUSTOM_BPI_FRAGMENT_QUERY from 'src/graphql/BoardCustomBPIFragment.graphql';
import * as BOARD_RESULT_FRAGMENT_QUERY from 'src/graphql/BoardResultFragment.graphql';

@Component({
  components: {
    BoardInspector
  }
})
export default class BoardDetailsCard extends Vue {
  @Prop() board: Board;
  @Prop() show: boolean;

  description = this.board.description;
  updateDescriptionDebounced = _.debounce(this.updateDescription, 1000);
  use_custom_bpi = this.board.use_custom_bpi;
  custom_bpi: string = this.board.custom_bpi != null ? this.board.custom_bpi.toString() : '';
  updateCustomBPIDebounced = _.debounce(this.updateCustomBPI, 500);
  loadingCustomBPI = false;

  @Watch('show')
  onShowChange() {
    if (this.show) {
      // This is needed for auto-grow initial size.
      const description = this.description;
      this.description = this.description + " ";

      this.$nextTick(() => {
        this.description = description;
      });
    }
  }

  get project() {
    return this.$store.state.currentProject;
  }

  @Watch('board.description')
  onBoardDescription() {
    if (this.description !== this.board.description) {
      this.description = this.board.description;
    }
  }

  @Watch('description')
  onWatchDescription() {
    this.updateDescriptionDebounced();
  }

  @Watch('board.use_custom_bpi')
  onBoardUseCustomBPI() {
    if (this.use_custom_bpi !== this.board.use_custom_bpi) {
      this.use_custom_bpi = this.board.use_custom_bpi;
    }
  }

  @Watch('use_custom_bpi')
  onWatchUseCustomBPI() {
    this.updateUseCustomBPI();
  }

  @Watch('board.custom_bpi')
  onBoardCustomBPI() {
    if (parseFloat(this.custom_bpi) !== this.board.custom_bpi && this.board.custom_bpi != null) {
      this.custom_bpi = this.board.custom_bpi.toString();
    }
  }

  @Watch('custom_bpi')
  onWatchCustomBPI() {
    this.loadingCustomBPI = true;
    this.updateCustomBPIDebounced();
  }

  onBPIFocus() {
    this.use_custom_bpi = true;
  }

  async onSubmitSimulation() {
    boardSubmitSimulation(this.board, this.project, this.$store);
  }

  updateDescription() {
    if (this.description === this.board.description)
      return;

    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $description: String!) {
          updateBoardDescription(projectId: $projectId, boardId: $boardId, description: $description) {
            ...BoardDescription
          }
        }
        ${BOARD_DESCRIPTION_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: this.board.id,
        description: this.description,
      },
      context: {
        debounceKey: 'BoardDescription',
      },
      update: (store, {data: { updateBoardDescription }}) => {
        let board = JSON.parse(JSON.stringify(this.board));
        board.description = this.description;

        store.writeFragment({
          id: `Board:${this.board.id}`,
          fragment: BOARD_DESCRIPTION_FRAGMENT_QUERY,
          data: board
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateBoardDescription: {
          __typename: 'Board',
          description: this.description
        },
      },
    });
  }

  updateUseCustomBPI() {
    if (this.use_custom_bpi === this.board.use_custom_bpi)
      return;

    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $useCustomBpi: Boolean!) {
          updateBoardUseCustomBPI(projectId: $projectId, boardId: $boardId, useCustomBpi: $useCustomBpi) {
            ...BoardUseCustomBPI
          }
        }
        ${BOARD_USE_CUSTOM_BPI_FRAGMENT_QUERY}
        ${BOARD_RESULT_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: this.board.id,
        useCustomBpi: this.use_custom_bpi,
      },
      update: (store, {data: { updateBoardUseCustomBPI }}) => {
        let board = JSON.parse(JSON.stringify(this.board));
        board.use_custom_bpi = this.use_custom_bpi;
        board.board_result = null;

        store.writeFragment({
          id: `Board:${this.board.id}`,
          fragment: BOARD_USE_CUSTOM_BPI_FRAGMENT_QUERY,
          fragmentName: 'BoardUseCustomBPI',
          data: board,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateBoardUseCustomBPI: {
          __typename: 'Board',
          use_custom_bpi: this.use_custom_bpi,
          board_result: null,
        },
      },
    });
  }

  updateCustomBPI() {
    const custom_bpi_float = parseFloat(this.custom_bpi)
    this.loadingCustomBPI = false;

    if (custom_bpi_float === this.board.custom_bpi || this.custom_bpi === '' || !isFinite(custom_bpi_float))
      return;

    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $customBpi: Float!) {
          updateBoardCustomBPI(projectId: $projectId, boardId: $boardId, customBpi: $customBpi) {
            ...BoardCustomBPI
          }
        }
        ${BOARD_CUSTOM_BPI_FRAGMENT_QUERY}
        ${BOARD_RESULT_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: this.board.id,
        customBpi: custom_bpi_float,
      },
      context: {
        debounceKey: 'BoardCustomBPI',
      },
      update: (store, {data: { updateBoardCustomBPI }}) => {
        let board = JSON.parse(JSON.stringify(this.board));
        board.custom_bpi = custom_bpi_float;
        board.board_result = null;

        store.writeFragment({
          id: `Board:${this.board.id}`,
          fragment: BOARD_CUSTOM_BPI_FRAGMENT_QUERY,
          fragmentName: 'BoardCustomBPI',
          data: board,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateBoardCustomBPI: {
          __typename: 'Board',
          custom_bpi: this.custom_bpi,
          board_result: null,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoardDetailsCard.vue